import { render, staticRenderFns } from "./imprint.html?vue&type=template&id=807bf182&scoped=true&"
import script from "./imprint.js?vue&type=script&lang=js&"
export * from "./imprint.js?vue&type=script&lang=js&"
import style0 from "./imprint.scss?vue&type=style&index=0&id=807bf182&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807bf182",
  null
  
)

export default component.exports